<template>
  <div>
    <section class="section is-title-bar">
      <div class="level is-mobile">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Create Announcement</p>
          </div>
        </div>
        <div class="level-right">
          <div class="buttons">
            <router-link
              :to="{ name: 'announcementList' }"
              class="button is-info is-small btnicon"
              title="Back To List"
            >
              Back To List
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="container section is-main-section">
      <form @submit.prevent="save">
        <div>
          <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label"
                  >Select Academic Year
                  <span class="has-text-danger">*</span></label
                >
                <div class="control">
                  <div class="select is-fullwidth">
                    <select v-model="academicYearID" required>
                      <option value="">-select</option>
                      <option
                        v-for="year in academicYears"
                        :key="year.id"
                        :value="year.id"
                      >
                        {{ year.academicYear }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="field">
                <label class="label">
                  User type<span class="has-text-danger">*</span>
                </label>
                <div class="control select is-fullwidth">
                  <select
                    v-on:change="clearData()"
                    name="userSelect"
                    required
                    v-model="UserType"
                  >
                    <option disabled value>--Select--</option>
                    <option value="STAFF_STAFF">ALL STAFF</option>
                    <option value="STAFF_TEACHING">TEACHING</option>
                    <option value="STAFF_NON_TEACHING">NON TEACHING</option>
                    <option value="PARENT">PARENT / STUDENT</option>
                    <option value="STUDENT_WISE">STUDENT WISE</option>
                    <option value="ALL">ALL</option>
                  </select>
                </div>
              </div>
            </div>
            <div
              v-if="this.UserType !== 'STUDENT_WISE'"
              class="column border-down is-4"
            >
              <div class="field">
                <label class="label">
                  Select Franchisee<span class="requir has-text-danger"
                    >*</span
                  ></label
                >
                <div class="control is-fullwidth">
                  <multiselect
                    class="overflowmultiselect2"
                    label="companyName"
                    track-by="companyName"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :preselect-first="false"
                    :multiple="true"
                    :options="franchiseeArr"
                    v-model="selectedFranchisee"
                  >
                  </multiselect>
                </div>
              </div>
            </div>
            <div v-if="this.UserType === 'STUDENT_WISE'" class="column">
              <div class="field">
                <label class="label"
                  >Select franchisee
                  <span class="has-text-danger">*</span></label
                >
                <multiselect
                  class="overflowmultiselect2"
                  label="companyName"
                  track-by="companyName"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :preselect-first="false"
                  :multiple="true"
                  :options="franchiseeArr"
                  v-model="franchiseeID"
                >
                </multiselect>
              </div>
            </div>
          </div>
          <div v-if="this.UserType === 'PARENT'">
            <div class="columns row">
              <div class="column is-4">
                <div class="field">
                  <label class="label"
                    >Select Gender<span class="has-text-danger">*</span></label
                  >
                  <div class="control p-t-7" required>
                    <b-radio name="gender" v-model="gender" native-value="ALL">
                      ALL
                    </b-radio>
                    <b-radio name="gender" v-model="gender" native-value="MALE">
                      MALE
                    </b-radio>
                    <b-radio
                      name="gender"
                      v-model="gender"
                      native-value="FEMALE"
                    >
                      FEMALE
                    </b-radio>
                  </div>
                </div>
              </div>
              <div class="column is-3">
                <div class="field">
                  <label class="label"
                    >class / section Wise<span class="has-text-danger"
                      >*</span
                    ></label
                  >
                  <div class="control p-t-7">
                    <b-radio
                      @input="clearclassSection()"
                      required
                      name="classSection"
                      v-model="classSection"
                      native-value="class"
                      class="m-r-7"
                    >
                      class
                    </b-radio>
                    <b-radio
                      name="classSection"
                      v-model="classSection"
                      native-value="section"
                    >
                      section
                    </b-radio>
                  </div>
                </div>
              </div>
              <div
                v-if="this.classSection === 'class'"
                class="column border-down is-5"
              >
                <div class="field">
                  <label class="label">
                    Select classes
                    <span class="requir has-text-danger">*</span>
                  </label>
                  <div class="control select is-fullwidth">
                    <multiselect
                      class="overflowmultiselect2"
                      label="name"
                      track-by="id"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :preselect-first="false"
                      :multiple="true"
                      :options="classes"
                      v-model="classSelects"
                    >
                    </multiselect>
                  </div>
                </div>
              </div>
              <div
                v-if="this.classSection === 'section'"
                class="column border-down is-5"
              >
                <div class="field">
                  <label class="label">
                    Select section
                    <span class="requir has-text-danger">*</span>
                  </label>
                  <div class="control select is-fullwidth">
                    <multiselect
                      class="overflowmultiselect2"
                      label="name"
                      track-by="id"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :preselect-first="false"
                      :multiple="true"
                      :options="tempArray"
                      v-model="sectionSelects"
                    >
                    </multiselect>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns row">
              <div class="column is-4">
                <div class="field">
                  <label class="label"
                    >Select Transport<span class="has-text-danger"
                      >*</span
                    ></label
                  >
                  <div class="control p-t-7">
                    <b-radio
                      name="transportType"
                      v-model="transportType"
                      native-value="ALL"
                    >
                      ALL
                    </b-radio>
                    <b-radio
                      name="transportType"
                      v-model="transportType"
                      native-value="YES"
                    >
                      YES
                    </b-radio>
                    <b-radio
                      name="transportType"
                      v-model="transportType"
                      native-value="NO"
                    >
                      NO
                    </b-radio>
                  </div>
                </div>
              </div>
              <div class="column is-4">
                <div class="field">
                  <label class="label"
                    >Student Type<span class="has-text-danger">*</span></label
                  >
                  <div class="control p-t-7">
                    <b-radio
                      name="studentType"
                      v-model="studentType"
                      native-value="ALL"
                    >
                      ALL
                    </b-radio>
                    <b-radio
                      name="studentType"
                      v-model="studentType"
                      native-value="NEW"
                    >
                      NEW
                    </b-radio>
                    <b-radio
                      name="studentType"
                      v-model="studentType"
                      native-value="EXISTING"
                    >
                      EXISTING
                    </b-radio>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="this.UserType === 'STUDENT_WISE'">
            <div class="columns form-row">
              <div class="column">
                <div class="field">
                  <label class="label">
                    Class-Section <span class="has-text-danger">*</span>
                  </label>
                  <div class="control">
                    <multiselect
                      class="overflowmultiselect2"
                      label="value"
                      track-by="id"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :preselect-first="false"
                      :multiple="true"
                      :options="classSectionArray"
                      v-model="classSectionID"
                    >
                    </multiselect>
                  </div>
                </div>
              </div>
              <div class="column border-down is-5">
                <div class="field">
                  <label class="label">
                    Select Student
                    <span class="requir has-text-danger">*</span>
                  </label>
                  <div class="control select is-fullwidth">
                    <multiselect
                      class="overflowmultiselect2"
                      label="displayname"
                      track-by="id"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :preselect-first="false"
                      :multiple="true"
                      :options="studentArray"
                      v-model="selectedStudent"
                    >
                    </multiselect>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="columns row">
            <div class="column is-4">
              <div class="field">
                <label class="label">
                  Type<span class="has-text-danger">*</span>
                </label>
                <div class="control select is-fullwidth">
                  <select name="type" required v-model="type">
                    <option disabled value>--Select--</option>
                    <option v-for="item in typeData" :key="item.key" :value="item.id">{{ item.name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-4">
              <div class="field">
                <label class="label">
                  Title <span class="has-text-danger">*</span></label
                >
                <div class="control">
                  <input
                    class="input"
                    v-model.trim="title"
                    required
                    type="text"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="columns row" style="width: 100%">
            <div class="columns form-row" style="width: 100%">
              <div class="column is-12">
                <div class="field">
                  <label class="label">
                    Description <span class="has-text-danger">*</span></label
                  >
                    <quill-editor
                      v-model="discription"
                      theme="snow"
                      ref="myQuillEditor"
                    >
                    </quill-editor>
                </div>
              </div>
            </div>
          </div>
          <div class="columns form-row">
            <div class="column">
              <div class="field">
                <label class="label"> select file </label>
                <b-field class="file is-primary">
                  <b-upload
                    @input="onFilechange()"
                    v-model="dropFile"
                    multiple
                    class="file-label"
                  >
                    <span class="file-cta">
                      <b-icon class="file-icon" icon="upload"></b-icon>
                      <span class="file-label">Click to upload</span>
                    </span>
                  </b-upload>
                </b-field>
                <span class="has-text-danger"
                  >Allowed files: .gif, .png, .jpg, .jpeg, .xlsx, .xls, .csv,
                  .doc, .pdf, .txt, .docx, .pptx, .pptm, .ppt, .xps, .potx,
                  .potm, .pot, thmx, .ppsx, .pps, .ppam, .ppa, .mp3, .wma, .aac,
                  .wav, .flac, .mp4, .avi, .m4p, .m4v, .wmv, .mov, .webm, .mpg,
                  .mp2, .mpeg, .mpe, .mpv, .ogg, .flv, .mkv</span
                >
                <br /><br />
                <span class="has-text-danger"
                  >File's that are not supported will be removed
                  automatically!</span
                >
                <span v-if="dropFile.length > 0">
                  <div class="tags" v-for="(file, i) in dropFile" :key="i">
                    <span class="tag is-primary">
                      {{ file.name }}
                    </span>
                    <button
                      class="delete is-small"
                      type="button"
                      @click="deleteDropFile(i)"
                    ></button>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div v-if="UserType === 'PARENT' || UserType === 'STUDENT_WISE'" class="event-block">
            <v-row>
              <v-col class="d-flex flex-row justify-start align-center" cols="12" md="12" lg="12" xs="12" sm="12">
                <label class="label mr-4">Mark as Event <span class="red--text">*</span></label>
                <v-radio-group
                  v-model="isEventType"
                  row
                  required
                  hide-details
                  class="mt-n3"
                >
                  <v-radio
                    label="Yes"
                    value="yes"
                  ></v-radio>
                  <v-radio
                    label="No"
                    value="no"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <template v-if="isEventType==='yes'">
                <v-col class="d-flex flex-row justify-start align-center" cols="12" md="12" lg="12" xs="12" sm="12">
                  <label class="label mr-4">Add Event Date <span class="red--text">*</span></label>
                  <v-menu ref="eventDateMenu" v-model="eventDateMenu" :close-on-content-click="false" :return-value.sync="eventDates" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field class="pt-0 mt-n2" style="max-width:400px;" hide-details v-model="eventDates" aria-required="true" placeholder="Pick event date" append-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="eventDates" :min="minStartDate" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="eventDateMenu = false">
                        Cancel
                      </v-btn>
                      <v-btn text color="primary" @click="$refs.eventDateMenu.save(eventDates)">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col class="d-flex flex-row justify-start align-center" cols="12" md="12" lg="12" xs="12" sm="12">
                  <label class="label mr-4">Add Event Time <span class="red--text">*</span></label>
                  <v-menu
                    ref="eventTimeMenu"
                    v-model="eventTimeMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="eventTime"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="pt-0 mt-n2"
                        style="max-width:400px;"
                        hide-details
                        v-model="eventTime"
                        aria-required="true"
                        placeholder="Pick event time"
                        append-icon="mdi-clock-time-four-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>
                    <v-time-picker v-if="eventTimeMenu" v-model="eventTime" full-width format="24hr" @click:minute="$refs.eventTimeMenu.save(eventTime)"></v-time-picker>
                  </v-menu>
                </v-col>
              </template>
            </v-row>
          </div>
          <button
            class="button is-success"
            :disabled="hasClicked"
            type="submit"
            style="margin-top: 38px"
          >
            Create
          </button>
        </div>
        <div></div>
      </form>
    </section>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import _ from 'lodash'
import Utils from '@/utils'
import Multiselect from 'vue-multiselect'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
  name: 'addAnnouncement',
  components: {
    Multiselect,
    quillEditor
  },
  data () {
    return {
      total: 0,
      termList: [],
      term: '',
      terms: [],
      dropFile: [],
      franchiseeID: '',
      franchiseeArr: [],
      academicYearID: '',
      classSelects: '',
      sectionSelects: '',
      selectedStudent: [],
      studentData: [],
      classSection: '',
      classSectionArray: [],
      discription: '',
      UserType: '',
      type: '',
      selectedFranchisee: [],
      transportType: 'ALL',
      studentType: 'ALL',
      academicYears: [],
      sendStudent: [],
      sendFranchisee: [],
      selectedClassID: '',
      academicTermDateMapid: '',
      selectedSectionID: '',
      classID: '',
      gender: 'ALL',
      title: '',
      classWiseSections: [],
      classSectionID: '',
      classes: [],
      sections: [],
      tempArray: [],
      typeData: [],
      studentArray: [],
      sendClass: [],
      sendSection: [],
      hasClicked: false,
      loader: true,
      sendData: {},
      selectedfranchiseeID: [],
      isWrite: false,
      allowedFiles: [
        'gif',
        'png',
        'jpg',
        'jpeg',
        'xlsx',
        'xls',
        'csv',
        'doc',
        'pdf',
        'txt',
        'docx',
        'pptx',
        'pptm',
        'ppt',
        'xps',
        'potx',
        'potm',
        'pot',
        'thmx',
        'ppsx',
        'pps',
        'ppam',
        'ppa',
        'mp3',
        'wma',
        'aac',
        'wav',
        'flac',
        'mp4',
        'avi',
        'm4p',
        'm4v',
        'wmv',
        'mov',
        'webm',
        'mpg',
        'mp2',
        'mpeg',
        'mpe',
        'mpv',
        'ogg',
        'flv',
        'mkv'
      ],
      eventDateMenu: false,
      isEventType: '',
      eventDates: null,
      minStartDate: new Date().toISOString().slice(0, 10),
      eventTimeMenu: false,
      eventTime: null

    }
  },
  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getClassList()
    await this.getFranchiseeList()
    await this.getYear()
    await this.gettype()
  },
  beforeRouteLeave (to, from, next) {
    // Ckeditor maximize fix and Alert on unsaved changes
    // const that = this.$refs.ckeditorRef
    // const maximizedState = that.instance.getCommand('maximize').state
    // if (maximizedState === 1) { that.instance.execCommand('maximize') }
    // if (this.hasDataChanged() && !this.hasClicked) {
    //   return this.$buefy.dialog.confirm({
    //     title: 'Leave Page',
    //     message: 'Do you really want to leave? you have unsaved changes!',
    //     type: 'is-danger',
    //     cancelText: 'No',
    //     confirmText: 'Yes',
    //     onConfirm: () => { next() },
    //     onCancel: () => { next(false) }
    //   })
    // } else
    next()
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventNav)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.preventNav)
  },
  watch: {
    UserType: function (newVal) {
    },
    franchiseeID: async function () {
      this.classSectionID = []
      this.studentArray = []
      this.selectedStudent = []
      if (this.academicYearID && this.franchiseeID) {
        await this.getClassSectionList()
      }
    },
    academicYearID: async function () {
      if (this.academicYearID && this.franchiseeID) {
        await this.getClassSectionList()
      }
    },
    classSectionID: async function () {
      await this.getStudents()
    }
  },
  methods: {
    preventNav (event) {
      if (!this.hasDataChanged()) return
      event.preventDefault()
      event.returnValue = ''
    },
    hasDataChanged () {
      const boolAlert =
        this.discription ||
        this.dropFile.length > 0 ||
        this.title ||
        this.UserType ||
        this.type ||
        this.selectedFranchisee.length > 0
      return boolAlert
    },
    getYear: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`
        )
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find((y) => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    gettype: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(
          `${constants.API_URL}/api/communication/announcements/type`
        )
        this.typeData = data
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/franchisee/active`
        )
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getClassList: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(
          `${constants.API_URL}/api/student/class-section?isRequired=false`
        )
        if (data) {
          this.classes = data.map((obj) => {
            return {
              id: obj.id,
              name: obj.name
            }
          })
          this.sections = data.map((obj) => {
            return {
              id: obj.id,
              name: obj.name,
              sections: obj.studentSections
            }
          })
        }
        data.map((a) => {
          a.studentSections.map((b) => {
            this.tempArray.push({
              id: b.id,
              name: `${a.name}-${b.name}`
            })
          })
        })
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    getClassSectionList: async function () {
      try {
        this.isLoading = true
        const fb = []
        this.classSectionArray = []
        let fbString = ''
        if (this.franchiseeID.length > 0) {
          // this.franchiseeID = this.franchiseeID
          if (
            typeof this.franchiseeID === 'object' &&
            this.franchiseeID !== null
          ) {
            this.franchiseeID.forEach((element) => {
              fb.push(element.id)
            })
          }
          if (fb.length > 0) {
            fbString = fb.toString()
          }
          let { data } = await http.get(
            `${constants.API_URL}/api/student/get-all-classby-franchisee?franchiseeID=${fbString}&academicYearID=${this.academicYearID}`
          )
          if (data) {
            var z = []
            _.map(data, (a) => {
              _.map(a.studentSections, (b) => {
                let franchiseeName =
                  b.studentAdmissions[0].franchisee.companyName
                let franchiseeId = b.studentAdmissions[0].franchisee.id
                b.value = `${franchiseeName}-${a.name} - ${b.name}`
                b.id = { franchiseeID: franchiseeId, sectionID: b.id }
                z.push(b)
              })
            })
          }
          this.classSectionArray = z
          this.isLoading = false
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        // this.errMsg(errorMessage)
        return this.$buefy.toast.open({
          message: errorMessage,
          type: 'is-danger',
          duration: 4000
        })
      }
    },
    changeSections: async function () {
      this.selectedStudent = []
      this.studentArray = []
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let sectionarray = this.sections.find(
          (obj) => obj.id === this.selectedClassID
        )
        if (sectionarray) {
          this.classWiseSections = sectionarray.sections
        } else {
          this.classWiseSections = 0
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.loadingComponent.close()
      }
    },
    students: async function () {
      if (this.UserType === 'STUDENT_WISE' && this.franchiseeID.length === 0) {
        return this.$buefy.toast.open({
          message: 'Please select Franchisee',
          type: 'is-danger',
          duration: 4000
        })
      }
      this.selectedStudent = []
      this.studentArray = []
      let studentData = {
        isActive: 'true',
        franchiseeID: this.franchiseeID,
        classID: this.selectedClassID,
        sectionID: this.selectedSectionID,
        academicYearID: this.academicYearID
      }
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let { data } = await http.post(
          `${constants.API_URL}/api/student`,
          studentData
        )
        if (data.length === 0) {
          this.$buefy.snackbar.open({
            duration: 7000,
            message: `No student Found with selected class and section`,
            position: 'is-top-right',
            type: 'is-danger'
          })
        } else {
          this.studentArray = data.map((a) => {
            return {
              id: a.id,
              name: a.studentEnrollment.studentName
            }
          })
        }
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Data', errorMessage)
      }
    },
    getStudents: async function () {
      if (this.UserType === 'STUDENT_WISE' && this.franchiseeID.length === 0) {
        return this.$buefy.toast.open({
          message: 'Please select Franchisee',
          type: 'is-danger',
          duration: 4000
        })
      }
      try {
        if (this.classSectionID.length > 0) {
          this.studentArray = []
          let franchiseeSectionClassMap = []
          this.classSectionID.map((b) => {
            franchiseeSectionClassMap.push({
              franchiseeID: b.id.franchiseeID,
              classID: b.classID,
              sectionID: b.id.sectionID
            })
          })
          this.isLoading = true
          let obj = {
            isActive: true,
            franchiseeSectionClassMap,
            academicYearID: this.academicYearID
          }

          let res = await http.post(
            `${constants.API_URL}/api/student/class-section-wise`,
            obj
          )
          if (res.data) {
            this.studentArray = res.data
          }
          this.studentArray = _.map(this.studentArray, (a) => {
            a.displayname = `${a.studentEnrollment.studentName} | ${a.franchisee.companyName} | ${a.studentClass.name} | ${a.studentSection.name}`
            return a
          })
          // }
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    save: async function () {
      /** Remove Empty <p> tags classwork **/
      let discriptionTest = this.discription
      discriptionTest = discriptionTest.replace(/(<([^>]+)>)/gi, '')
      discriptionTest = discriptionTest.replace(/&nbsp;/g, '')
      discriptionTest = discriptionTest.trim()
      if (discriptionTest === '' || discriptionTest === null) {
        return this.$buefy.toast.open({
          message: 'Please fill Description',
          type: 'is-danger',
          duration: 4000
        })
      }
      if (
        this.UserType !== 'STUDENT_WISE' &&
        this.selectedFranchisee.length === 0
      ) {
        return this.$buefy.toast.open({
          message: 'Please select Franchisee',
          type: 'is-danger',
          duration: 4000
        })
      }
      if (this.classSection === 'class' && this.classSelects.length === 0) {
        return this.$buefy.toast.open({
          message: 'Please select class',
          type: 'is-danger',
          duration: 4000
        })
      }
      if (this.classSection === 'section' && this.sectionSelects.length === 0) {
        return this.$buefy.toast.open({
          message: 'Please select Section',
          type: 'is-danger',
          duration: 4000
        })
      }
      if (
        this.UserType === 'STUDENT_WISE' &&
        this.selectedStudent.length === 0
      ) {
        return this.$buefy.toast.open({
          message: 'Please select Student',
          type: 'is-danger',
          duration: 4000
        })
      }
      if (this.UserType === 'STUDENT_WISE' || this.UserType === 'PARENT') {
        if (_.isEmpty(this.isEventType)) {
          return this.$buefy.toast.open({
            message: 'Please select mark as event',
            type: 'is-danger',
            duration: 4000
          })
        }
      }
      if (this.UserType !== 'STUDENT_WISE' && this.UserType !== 'PARENT') {
        this.isEventType = 'no'
      }
      if (this.isEventType === 'yes') {
        if (!this.eventDates) {
          return this.$buefy.toast.open({
            message: 'Please select event date',
            type: 'is-danger',
            duration: 4000
          })
        }
        if (!this.eventTime) {
          return this.$buefy.toast.open({
            message: 'Please select event time',
            type: 'is-danger',
            duration: 4000
          })
        }
      }
      try {
        this.loadingComponent = this.$buefy.loading.open()
        if (this.classSelects.length > 0) {
          this.sendClass = this.classSelects.map((obj) => obj.id)
        }
        if (this.sectionSelects.length > 0) {
          this.sendSection = this.sectionSelects.map((obj) => obj.id)
        }
        if (this.selectedStudent.length > 0) {
          this.sendStudent = this.selectedStudent.map((obj) => obj.id)
        }
        if (this.selectedFranchisee.length > 0) {
          this.sendFranchisee = this.selectedFranchisee.map((obj) => obj.id)
        }
        if (this.franchiseeID) {
          this.selectedfranchiseeID = this.franchiseeID.map((obj) => obj.id)
        }

        this.studentData = [this.selectedStudent]
        let formData = new FormData()
        formData.append('academicYearID', this.academicYearID)
        formData.append('userType', this.UserType)
        formData.append('typeID', this.type)
        formData.append('title', this.title)
        formData.append('descriptions', this.discription)
        formData.append('studentType', this.studentType)
        formData.append('transportType', this.transportType)
        formData.append('genderType', this.gender)
        formData.append('isEventType', this.isEventType)
        if (this.isEventType === 'yes') {
          formData.append('eventDate', this.eventDates)
          formData.append('eventTime', this.eventTime)
        }
        if (this.selectedStudent.length !== 0) {
          formData.append('studentIds', JSON.stringify(this.sendStudent))
        }
        if (this.selectedFranchisee.length !== 0) {
          formData.append('franchiseeID', JSON.stringify(this.sendFranchisee))
        }
        if (this.franchiseeID.length !== 0) {
          formData.append(
            'franchiseeID',
            JSON.stringify(this.selectedfranchiseeID)
          )
        }
        if (this.classSection === 'class') {
          formData.append('classIds', JSON.stringify(this.sendClass))
        }
        if (this.classSection === 'section') {
          formData.append('sectionIds', JSON.stringify(this.sendSection))
        }
        for (let i = 0; i < this.dropFile.length; i++) {
          formData.append('file', this.dropFile[i])
        }
        this.hasClicked = true

        await http.post(
          `${constants.API_URL}/api/communication/announcements`,
          formData
        )
        this.loader = false
        this.resetInputs()
        this.loadingComponent.close()
        this.$router.push({ name: 'announcementList' })
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    clearAll: async function () {
      this.selectedClassID = ''
      this.selectedSectionID = ''
      this.selectedStudent = []
      this.studentArray = []
    },
    resetInputs () {
      this.userType = ''
      this.academicYearID = ''
      this.franchiseeID = ''
      this.typeID = ''
      this.title = ''
      this.descriptions = ''
      this.selectedfranchiseeID = []
    },
    clearData () {
      this.classSection = ''
      this.selectedFranchisee = []
      this.franchiseeID = ''
      this.classSelects = ''
      this.sectionSelects = ''
      this.studentArray = []
      this.selectedStudent = []
      this.selectedClassID = ''
      this.selectedSectionID = ''
    },
    onFilechange () {
      let r = this.dropFile.filter((a, i) => {
        if (this.allowedFiles.includes(a.name.split('.').pop())) {
        }
        return this.allowedFiles.includes(a.name.split('.').pop())
      })
      this.dropFile = r
    },
    clearclassSection () {
      this.classSelects = ''
      this.sectionSelects = ''
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
textarea {
  background-color: #ffffff;
  border-color: #dbdbdb;
  border-radius: 4px;
  color: #363636;
  height: 9.5rem;
}
</style>
